export const GET_LEGAL_TEXTS = 'LEGAL/GET_LEGAL_TEXTS'
export const GET_LEGAL_TEXTS_SUCCESS = 'LEGAL/GET_LEGAL_TEXTS_SUCCESS'
export const GET_LEGAL_TEXTS_ERROR = 'LEGAL/GET_LEGAL_TEXTS_ERROR'
